module.exports = __webpack_public_path__ + "static/media/ca.a3999867.svg";